import { useGetIdentity, useGetList, type Identifier } from "ra-core";

export interface Agent {
  id: Identifier;
  first_name: string;
  last_name: string;
  disabled?: boolean;
  /** Test or company profiles: never given leads, calls or tasks */
  no_work?: boolean;
}

export const agentName = (agent?: Agent | null): string =>
  agent ? `${agent.first_name} ${agent.last_name}`.trim() : "";

/** Team members (CRM users) and the one who is signed in. */
export const useAgents = () => {
  const { identity } = useGetIdentity();
  const { data: agents = [] } = useGetList<Agent>("sales", {
    filter: { disabled: false },
    pagination: { page: 1, perPage: 50 },
    sort: { field: "id", order: "ASC" },
  });
  const findAgent = (id?: Identifier | null) =>
    id == null
      ? undefined
      : agents.find((agent) => String(agent.id) === String(id));
  return {
    agents,
    /** People who can be given leads, calls and tasks */
    workers: agents.filter((agent) => !agent.no_work),
    meId: identity?.id as Identifier | undefined,
    findAgent,
    nameOf: (id?: Identifier | null) => agentName(findAgent(id)),
  };
};

/** Current call slot (team's local time), matching CALL_SLOTS values. */
export const currentCallSlot = (date = new Date()): string | null => {
  const hour = date.getHours();
  if (hour >= 9 && hour < 14) return "9-14";
  if (hour >= 14 && hour < 18) return "14-18";
  if (hour >= 18 && hour < 21) return "18-21";
  return null;
};

export const isInSlot = (
  callSlot: string | null | undefined,
  slot: string | null,
) => !!slot && !!callSlot && callSlot.split(",").includes(slot);
